import React from "react";
import { ariaDescribedByIds, enumOptionsDeselectValue, enumOptionsIsSelected, enumOptionsSelectValue, enumOptionsValueForIndex, optionId, } from "@rjsf/utils";
export default function CheckboxesWidget({ id, disabled, options, value, autofocus, readonly, required, onChange, onBlur, onFocus, }) {
    const { enumOptions, enumDisabled, inline, emptyValue } = options;
    const checkboxesValues = Array.isArray(value) ? value : [value];
    const _onChange = (index) => ({ target: { checked } }) => {
        if (checked) {
            onChange(enumOptionsSelectValue(index, checkboxesValues, enumOptions));
        }
        else {
            onChange(enumOptionsDeselectValue(index, checkboxesValues, enumOptions));
        }
    };
    const _onBlur = ({ target: { value } }) => onBlur(id, enumOptionsValueForIndex(value, enumOptions, emptyValue));
    const _onFocus = ({ target: { value } }) => onFocus(id, enumOptionsValueForIndex(value, enumOptions, emptyValue));
    return (React.createElement("div", { className: "space-y-4" }, Array.isArray(enumOptions) &&
        enumOptions.map((option, index) => {
            const checked = enumOptionsIsSelected(option.value, checkboxesValues);
            const itemDisabled = Array.isArray(enumDisabled) &&
                enumDisabled.indexOf(option.value) !== -1;
            return (React.createElement("div", { key: option.value, className: `flex items-center ${inline ? "space-x-2" : ""}` },
                React.createElement("input", { type: "checkbox", id: optionId(id, index), name: id, className: "form-checkbox border-0 bg-transparent", required: required, checked: checked, autoFocus: autofocus && index === 0, onChange: _onChange(index), onBlur: _onBlur, onFocus: _onFocus, disabled: disabled || itemDisabled || readonly, "aria-describedby": ariaDescribedByIds(id) }),
                React.createElement("label", { htmlFor: optionId(id, index), className: "cursor-pointer" }, option.label)));
        })));
}
//# sourceMappingURL=CheckboxesWidget.js.map